module.exports = __webpack_public_path__ + "img/logo-inline.ac5d0d09.svg";